<template>
  <fieldset class="form__subfieldset">
    <legend class="form__sublegend">
      <h4>{{ t('activityOccurrences.occurrence') }} #{{ index + 1 }}</h4>
      <button
          v-tippy="t(`global.actions.delete`)"
          class="btn btn--square btn--red"
          @click="deleteActivityRegistrationRow"
      >
        <IconDelete class="icon icon--black"/>
      </button>
    </legend>
    <FormRow with-three-columns>
      <FormInput
          :ref="addFormInputRef"
          v-model="occurrenceStartDate"
          :label="t('activityOccurrences.form.startDate')"
          :rules="[required]"
          name="startDate"
          type="date"
          @validated="handleValidation"/>
      <FormInput
          :ref="addFormInputRef"
          v-model="occurrenceEndDate"
          :label="t('activityOccurrences.form.endDate')"
          :rules="occurrenceEndDate.length && occurrenceStartDate.length ? [required, minDate(occurrenceStartDate)] : []"
          name="endDate"
          type="date"
          @validated="handleValidation"/>

      <div v-if="props.id && props.activityId" class="form__field">
        <label>{{ t("participants.nbParticipant") }}</label>
        <p class="form__field-readonly">
            <span>
              <span class="occupied-places">{{ props.occupiedPlaces }} / {{ props.maxParticipants ?? 0 }}</span>
            </span>
          <router-link
              :to="{ 'name': 'admin.children.activities.participants.edit', 'params': { activityId: props.activityId, activityOccurrenceId: props.id } }"
              class="btn btn--square btn--blue">
            <IconParticipants class="icon icon--black"/>
          </router-link>
        </p>
      </div>
    </FormRow>
  </fieldset>
</template>

<script lang="ts" setup>
import {ref, watch} from "vue";
import {minDate, required} from "@/validation/rules";
import {useI18n} from "vue3-i18n";
import FormInput from "@/components/forms/FormInput.vue";
import FormRow from "@/components/forms/FormRow.vue";
import {Status} from "@/validation";
import IconParticipants from "@/assets/icons/icon__person.svg"
import IconDelete from "@/assets/icons/icon__delete.svg"

const {t} = useI18n();

// eslint-disable-next-line no-undef
const props = defineProps<{
  index: number;
  id?: string;
  activityId?: string;
  startDate?: string;
  endDate?: string;
  maxParticipants?: number;
  occupiedPlaces?: number;
}>();

// eslint-disable-next-line
const emit = defineEmits<{
  (event: "update:startDate", value: string): void;
  (event: "update:endDate", value: string): void;
  (event: "handleValidation", name: string, validationStatus: Status): void
  (event: "registerFormInputRef", ref: typeof FormInput): void
  (event: "addActivityOccurrenceRow"): void
  (event: "removeActivityOccurrenceRow", rowIndex?: number): void
}>();


const occurrenceStartDate = ref(props.startDate ? props.startDate : "");
watch(occurrenceStartDate, (newValue) => emit("update:startDate", newValue));

const occurrenceEndDate = ref(props.endDate ? props.endDate : "");
watch(occurrenceEndDate, (newValue) => emit("update:endDate", newValue));

watch(props, (newProps) => {
  occurrenceStartDate.value = newProps.startDate ? newProps.startDate : "";
  occurrenceEndDate.value = newProps.endDate ? newProps.endDate : "";
});

function addFormInputRef(ref: typeof FormInput) {
  emit("registerFormInputRef", ref);
}

async function handleValidation(name: string, validationStatus: Status) {
  emit("handleValidation", name, validationStatus);
}

function deleteActivityRegistrationRow() {
  emit("removeActivityOccurrenceRow", props.index)
}

</script>

<style lang="scss" scoped>
.participants-section {
  display: flex !important;
  flex-direction: column;
  font-size: 0.875rem;
  line-height: 2;

  .participants-count {
    width: 80%;
    display: flex !important;
    text-align: right;

    .occupied-places {
      margin-right: 20px;
    }
  }
}
</style>